import { Store as IDBStore, set, get, del } from 'idb-keyval';

interface StorageInstance {
  set: <T = string>(key: string, value: T) => Promise<T>;
  get: <T = string>(key: string) => Promise<T | null>;
  delete: (key: string) => Promise<void>;
}

class IDBAdapter implements StorageInstance {
  store: IDBStore;

  constructor() {
    this.store = new IDBStore("vodda.app", "store");
  }

  set<T = string>(key: string, value: T): Promise<T> {
    return set(key, value, this.store).then(() => value);
  }

  get<T = string>(key: string): Promise<T | null> {
    return get<T>(key, this.store);
  }

  delete(key: string): Promise<void> {
    return del(key);
  }
}

class LSAdapter implements StorageInstance {
  set<T = string>(key: string, value: T): Promise<T> {
    localStorage.setItem(key, JSON.stringify(value));
    return Promise.resolve(value);
  }

  get<T = string>(key: string): Promise<T | null> {
    const value = localStorage.getItem(key);
    const result = value ? JSON.parse(value) as T : null;

    return Promise.resolve(result);
  }

  delete(key: string): Promise<void> {
    return Promise.resolve(localStorage.removeItem(key));
  }
}

export const storage = 'indexedDB' in window ? new IDBAdapter() : new LSAdapter();